import { Suspense, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useAppDispatch } from 'core/store';
import { fetchModuleNavigation } from 'core/store/module-navigation';
import { Loading } from 'shared/components/loading';
import { RequireAuth } from 'shared/components/require-auth';
import { MainLayout } from '../main-layout';

export const ProtectedLayout = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchModuleNavigation());
  }, [dispatch]);
  return (
    <RequireAuth>
      <MainLayout maxWidthEnabled>
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    </RequireAuth>
  );
};
